<template>
  <div>
    <Modal v-model="visible" title="绑定第三方账号" :hasFooter="false" @on_cancel="closeModal">
      <template slot="body">
        <template v-if="successStatus">
          <div class="message-box">
            <div class="msg-item">
              <img class="hint-img" src="@/assets/svg/完成.svg" alt="" />
            </div>
            <div class="msg-item">
              <span class="msg">绑定成功</span>
            </div>
            <div class="msg-item">
              <span class="msg"> 您可以一键查看多个平台的资源</span>
            </div>
            <div class="login-btn__wrapper clearfix">
              <button class="login-btn login-btn_big active-login" @click="customLogin">
                我知道了
              </button>
            </div>
          </div>
        </template>
        <template v-if="!successStatus">
          <div :class="['login-box__wrapper', validAccount ? '' : 'err-focus']">
            <span
              class="login-input third-toggle"
              :class="{ 'tkn-dropdown-toggle': dropDown }"
              @click="down = !down"
            >
              <span>{{ currentText }}</span>
              <a-icon class="third-icon" type="caret-down" />
              <ul class="site-dropdown">
                <li v-for="item in sites" :key="item.name" @click="chooseSite(item)">
                  {{ item.name }}
                </li>
              </ul>
            </span>
            <!-- <span v-show="!validAccount" class="hint errright"></span> -->
          </div>
          <div :class="['login-box__wrapper', 'clearfix', account_error ? 'err-focus' : '']">
            <input
              @focus="getFocus"
              @blur="removeFocus"
              v-model="account"
              id="account"
              class="login-input"
              placeholder="请输入账号"
            />
            <span class="hint errright">{{ account_error }} </span>
          </div>
          <div :class="['login-box__wrapper', 'clearfix', password_error ? 'err-focus' : '']">
            <input
              @focus="getFocus"
              @blur="removeFocus"
              v-model="psw"
              class="login-input"
              placeholder="输入密码"
            />
            <span class="hint errright">{{ password_error }} </span>
          </div>
          <div
            v-if="imgCodeSrc"
            :class="['login-box__wrapper', 'clearfix', code_error ? 'err-focus' : '']"
          >
            <input
              @focus="getFocus"
              @blur="removeFocus"
              v-model="code"
              class="login-input login-input_min"
              placeholder="输入验证码"
            />
            <span class="hint errright">{{ code_error }} </span>
          </div>
          <div style="text-align: center;" class="login-btn__wrapper clearfix" v-if="imgCodeSrc">
            <ImgCode :src="imgCodeSrc" @get_new_img="getImageCode"></ImgCode>
          </div>
          <div style="text-align: center;" class="login-btn__wrapper clearfix" v-if="request_error">
            <span class="error-info">获取验证码失败，请稍后再试</span>
          </div>
          <div
            v-if="needPhone"
            :class="['login-box__wrapper', 'clearfix', code_error ? 'err-focus' : '']"
          >
            <input
              v-model="codePhone"
              @focus="getFocus"
              @blur="removeFocus"
              type="text"
              class="login-input login-input_big login-input_left login-input_psw fl"
              placeholder="验证码"
            />
            <span class="hint errcenter">{{ sms_code_error }} </span>
            <countBtn
              @result="resultHandler"
              :usage="resUse"
              class="modal-count"
              :value="account"
              :clean="clean"
              :address="address"
            ></countBtn>
          </div>
          <div class="login-btn__wrapper clearfix">
            <a-button
              :disabled="!validBind"
              :class="['login-btn', 'login-btn_big', validBind ? 'active-login' : 'disable']"
              @click="enroll"
              :loading="loading"
            >
              确认绑定
            </a-button>
          </div>
        </template>
      </template>
    </Modal>
  </div>
</template>
<script>
import { api_post } from '@/utils/http.ts'
import { msgTip } from '@/utils/urlUtils'
import ImgCode from '@/components/enroll/ImgCode.vue'
import partyMixin from '@/apps/party/mixin.js'
import Modal from './Modal.vue'
import CountBtn from './CountBtn.vue'

export default {
  name: 'ThirdPartyModal',
  mixins: [partyMixin],
  data() {
    return {
      //图片验证码
      request_error: '',
      down: false,
      imgCodeSrc: '',
      successStatus: false,
      sites: [{ name: '菁优网', val: 'jyeoo' }, { name: '学科网', val: 'zxxk' }],
      // sites: ['学科网', '菁优网', '21世纪组卷网', '百度文库'],
      currentText: '请选择第三方平台',
      currentSite: '',
      password_error: '',
      account_error: '',
      code_error: '',
      sms_code_error: '',
      //校验三方平台
      validAccount: true,
      //账户
      account: '',
      //验证码
      code: '',
      //密码
      psw: '',
      visible: this.value,
      codePhone: '', // 手机验证码
      clean: '',
      shape: '',
      loading: false,
      needPhone: false,
      address: '/search/api/auth/send-sms-code-3rd',
      verifyCode: '',
      dropDown: true
    }
  },
  computed: {
    resUse() {
      return {
        usage: '3rd-bind',
        phone: this.account,
        domain: 'zxxk',
        captcha: this.code
      }
    },
    validBind() {
      switch (this.currentSite) {
        case 'jyeoo':
          return this.currentText !== '请选择第三方平台' && this.account && this.psw && this.code
        case 'zxxk':
          if (this.needPhone) {
            return (
              this.currentText !== '请选择第三方平台' &&
              this.account &&
              this.psw &&
              this.code &&
              this.codePhone
            )
          } else {
            return this.currentText !== '请选择第三方平台' && this.account && this.psw
          }
        default:
          return false
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function(val) {
      this.visible = val
      if (this.visible) {
        this.clearData()
        this.currentText = '菁优网'
        this.currentSite = 'jyeoo'
      } else {
        this.currentText = '请选择第三方平台'
      }
    },
    currentText: {
      handler: function(val) {
        if (val != '请选择第三方平台') {
          this.validAccount = true
          //请求图片验证码
          // this.getImageCode(val)
        }
      },
      deep: true
    }
  },
  model: {
    prop: 'value',
    event: 'on_cancel'
  },
  methods: {
    chooseSite(val) {
      this.imgCodeSrc = '' // 清空
      this.needPhone = false
      this.currentText = val.name
      this.currentSite = val.val
      this.dropDown = false
      let that = this
      setTimeout(() => {
        that.dropDown = true
      }, 500)
    },
    resultHandler(msg) {
      if (msg) {
        this.code_error = msg
      } else {
        this.code_error = ''
      }
    },
    async getImageCode() {
      let request = {
        domain: this.currentSite,
        account: this.account
      }
      if (this.currentSite === 'zxxk') {
        request = { ...request, ...{ password: this.psw } }
      }
      let rdata = await api_post('/search/api/auth/account/add', request)
      if (rdata.success) {
        this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
      } else {
        this.account_error = rdata.account_error || ''
        this.request_error = rdata.request_error || ''
        if (rdata.data.captcha_image_src) {
          this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
        }
        // switch (rdata.code) {
        //   case 5:
        //     this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
        //     break
        //   default:
        //     break
        // }
      }
    },
    closeModal: function() {
      this.visible = false
      this.$emit('on_cancel')
    },
    hideHeader(flag) {
      let header = document.querySelector('.modal-header')
      let title = document.querySelector('.modal-title')
      if (flag) {
        if (header && title) {
          header.style.display = 'none'
          title.style.display = 'none'
        }
      } else {
        if (header && title) {
          header.style.display = 'block'
          title.style.display = 'block'
        }
      }
    },
    customLogin() {
      this.closeModal()
      this.successStatus = false
      this.hideHeader(false)
    },
    //
    showSuccessMsg() {
      this.successStatus = true
      //hide header
      this.hideHeader(true)
      let that = this
      setTimeout(() => {
        that.customLogin()
        this.successStatus = false
        this.hideHeader(false)
      }, 2000)
    },
    async realBind() {
      this.loading = true
      let rdata = await api_post('/search/api/auth/account/add', {
        domain: this.currentSite,
        account: this.account,
        password: this.psw,
        captcha: this.code,
        verifyCode: this.codePhone || ''
      })
      this.loading = false
      if (rdata.success) {
        this.showSuccessMsg()
        this.$emit('add', rdata)
        //
        setTimeout(() => {
          this.$sa.track('ContentRepository_Bind', {
            buttonName: '绑定成功'
          })
        }, 50)
      } else {
        this.password_error = rdata.password_error || ''
        this.account_error = rdata.account_error || ''
        this.code_error = rdata.code_error || rdata.ode_error || ''
        if (this.code_error) {
          this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
        }
        switch (rdata.code) {
          case 5:
            this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
            this.sms_code_error = rdata.sms_code_error || ''
            this.needPhone = true
            break
          default:
            break
        }
      }
    },
    enroll() {
      if (this.currentText == '请选择第三方平台') {
        this.validAccount = false
      } else {
        //verify
        switch (this.currentSite) {
          case 'jyeoo':
            if (this.psw && this.account && this.code) {
              //都不为空的情况下
              this.realBind()
            }
            break
          case 'zxxk':
            if (this.psw && this.account) {
              //都不为空的情况下
              this.realBind()
            }
            break
          default:
            break
        }
      }
      //
      setTimeout(() => {
        this.$sa.track('ContentRepository_Bind', {
          buttonName: '确认绑定'
        })
      }, 50)
    },
    removeFocus(e) {
      let id = e.target.id
      let targetParent = e.target.parentElement
      if (targetParent) {
        let classes = targetParent.classList
        classes.remove('nor-focus')
        if (id == 'account') {
          this.getImageCode()
        }
      }
    },
    getFocus(e) {
      let targetParent = e.target.parentElement
      if (targetParent) {
        targetParent.classList.add('nor-focus')
      }
    }
  },
  components: { Modal, ImgCode, CountBtn }
}
</script>
<style scoped lang="scss">
.error-info {
  text-align: center;
  color: rgba(0, 0, 0, 0.65);
}
.tkn-dropdown-toggle:hover .site-dropdown {
  // height: 151px;
  height: 80px;
}
.third-toggle {
  .site-dropdown {
    width: 100%;
  }
  width: 100% !important;
  .third-icon {
    float: right;
  }
}
.site-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  height: 0px;
  z-index: 1000;
  overflow: hidden;
  transition: height 0.3s ease;
  float: left;
  min-width: 160px;
  padding: 0px 0px;
  // display: none;
  margin: 2px 0 0;
  list-style: none;
  font-size: 14px;
  text-align: left;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16);
  -webkit-box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16);
  li {
    padding: 8px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  }
  li:hover {
    background: #e6f7ff;
  }
}
.message-box {
  text-align: center;
  .hint-img {
    height: 99px;
    width: 99px;
  }
  .msg-item {
    padding: 10px 0px;
    .msg {
      width: 160px;
      height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      line-height: 24px;
    }
  }
}
</style>
